import axios from 'axios';
import qs from 'qs';
import Utils from './utils';
import BlobRequest from './blob';

const DefaultParam = { repeatable: false };

let ajax = {
  PREFIX: '',
  Author: Utils.getAuthor() || 'heyui',
  requestingApi: new Set(),
  extractUrl: function (url) {
    return url ? url.split('?')[0] : '';
  },
  isRequesting: function (url) {
    let api = this.extractUrl(url);
    return this.requestingApi.has(api);
  },
  addRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.add(api);
  },
  deleteRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.delete(api);
  },
  get: function (url, param, extendParam, customErrors) {
    let params = {
      url,
      method: 'GET'
    };
    if (param) {
      params.params = param;
    }
    return this.ajax(params, extendParam, customErrors);
  },
  getCustom: function (url, param, extendParam) {
    // Response completo + status erros
    return this.get(url, param, extendParam, true);
  },
  getBlob: async function (url, param) {
    const resp = await this.get(url, param, { responseType: 'blob' });
    if (resp.ok === true) {
      BlobRequest.forceDownload(resp);
    }
    return resp;
  },
  post: function (url, param, extendParam) {
    var params = {
      url,
      method: 'POST'
    };
    if (param) params.data = qs.stringify(param);
    return this.ajax(params, extendParam);
  },
  postJson: function (url, paramJson, extendParam) {
    return this.ajax({
      url,
      method: 'POST',
      data: paramJson
    }, extendParam);
  },
  patchJson: function (url, paramJson, dataType, extendParam) {
    return this.ajax({
      url,
      method: 'PATCH',
      data: paramJson
    }, extendParam);
  },
  delete: function (url, extendParam) {
    return this.ajax({
      url: url,
      method: 'DELETE'
    }, extendParam);
  },
  head: function (url, extendParam, customErrors) {
    return this.ajax({
      url: url,
      method: 'HEAD'
    }, extendParam, customErrors);
  },
  ajax: function (param, extendParam, customErrors) {
    let params = Utils.extend({}, DefaultParam, param, extendParam || {});
    params.crossDomain = params.url.indexOf('http') === 0;
    let url = params.url;
    if (!params.crossDomain) {
      url = params.url = this.PREFIX + params.url;
    }

    if (params.method != 'GET') {
      if (this.isRequesting(url)) {
        return new Promise((resolve, reject) => { resolve({ ok: false, msg: 'Repetir pedido' }); });
      }
      if (params.repeatable === false) {
        this.addRequest(url);
      }
    }

    let v360User = Utils.getV360User();
    let header = {
      Authorization: `Bearer ${v360User.accessToken}`
    };

    let defaultParam = {
      headers: header,
      responseType: 'json',
      validateStatus: function (status) {
        return true;
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { allowDots: true, encode: false });
      }
    };
    if (params.crossDomain) {
      defaultParam.headers = {};
    }
    let that = this;
    params = Utils.extend({}, defaultParam, params);
    return new Promise((resolve) => {
      const axiosGlobalInstance = axios.create({
        baseURL: process.env.VUE_APP_ROOT_API
      });

      return axiosGlobalInstance.request(params).then((response) => {
        that.deleteRequest(params.url);

        let data = response.data || {};
        let status = response.status;
        // Se o encapsulamento unificado de backend retornar, ou seja, todas as solicitações forem 200, o código de erro será fornecido pelo resultado retornado e, em seguida, usará o seguinte código para obter o status
        /* if (status == 200) {
          status = data.status;
        } */
        if (!customErrors) {
          if (status != 200) {
            if (status == 401) {
              const urlHub = process.env.VUE_APP_URL_HUB;
              window.location.href = `${urlHub}/#/signin?continue=${window.location.origin}&service=vendas`;
              return;
            }
            if (status == 400) {
              HeyUI.$Message.error(data.error || 'Ocorreu um erro em sua solicitação.');
            } else if (status == 500) {
              HeyUI.$Message.error('Erro de servidor, por favor contate o admnistrador do sistema caso o erro persista');
            } else if (status == 404) {
              HeyUI.$Message.error('Nada encontrado !');
            } else if (status != 200) {
              if (typeof data.error === 'string') {
                HeyUI.$Message.error(data.error || 'Ocorreu um erro em sua solicitação');
              }
            }
          }
        }

        data.ok = status >= 200 && status < 300;
        data._response = response;
        resolve(data);
      }).catch((err) => {
        that.deleteRequest(params.url);
        resolve({
          ok: false,
          _error: err
        });
      });
    });
  }
};
export default ajax;
